import React from "react";
import { Grid, Card } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  selectDigitalbState,
  displaySingleInvoice,
  displayMainUtilityView,
  setIsTransactionSuccessfullyCompleted,
} from "../../../../../features/digitalb/digitalbSlice";
import {
  selectGlobalDataState,
  setGeneralMessage,
  setTransactionHasBeenMade,
} from "../../../../../features/global/globalDataSlice";
import {
  selectMyContractsState,
  resetSelectedContractInfo,
} from "../../../../../features/myContracts/myContractsSlice";
import smallLoadingAnimation from "../../../../../icons/lottieAnimations/smallLoading.json";
import DigitalbSingleExpandedInvoice from "../digitalb/DigitalbSingleExpandedInvoice";
import Lottie from "lottie-react";
import Digitalb from "./Digitalb";
import { useLocation } from "react-router-dom";
import { selectUserInfo } from "../../../../../features/userInfo/userInfoSlice";
import MyContractsTest from "../myContracts/myContractsNew/MyContractsTest";
import { texts } from "../../../../general/texts";
import DigitalbOTT from "./DigitalbOTT";

const UtilityTaksat = (props) => {
  const digitalbSliceState = useSelector(selectDigitalbState);
  const userInfo = useSelector(selectUserInfo);
  const globalDataSliceState = useSelector(selectGlobalDataState);
  const myContractsSliceState = useSelector(selectMyContractsState);
  const dispatch = useDispatch();
  const location = useLocation();
  const urlSegments = location.pathname.split("/");

  // Check if the last segment of the URL is "DIGITALBOTT"
  const isDigitalbOTT = urlSegments[urlSegments.length - 1] === "DIGITALBOTT";
  const utilityName = "DIGITALB";

  React.useEffect(() => {
    digitalbSliceState.shouldDisplaySingleInvoice &&
      dispatch(displaySingleInvoice());
    digitalbSliceState.shouldDisplayMainUtilityView &&
      dispatch(displayMainUtilityView());

    if (digitalbSliceState.isTransactionSuccessfullyCompleted) {
      dispatch(
        setGeneralMessage({
          type: "success",
          message: texts["message-success-trx"],
        })
      );
      dispatch(setIsTransactionSuccessfullyCompleted(false));
      dispatch(setTransactionHasBeenMade(true));
    }

    return () => {
      dispatch(resetSelectedContractInfo());
    };
  }, [
    digitalbSliceState.isTransactionSuccessfullyCompleted,
    digitalbSliceState.shouldDisplaySingleInvoice,
    digitalbSliceState.shouldDisplayMainUtilityView,
  ]);

  return (
    <Grid container spacing={"2%"} pt={"3%"}>
      <Grid
        container
        item
        md={6.5}
        justifyContent={"right"}
        sx={{ "@media (max-width: 899px)": { justifyContent: "center" } }}
      >
        <Card
          sx={{
            borderRadius: "20px",
            boxShadow: "0 0 15px 5px #E5E7EA",
            width: "60%",
            "@media (max-width: 1440px )": { width: "70%" },
            "@media (max-width: 1320px )": { width: "90%" },
          }}
        >
          {digitalbSliceState.shouldDisplaySingleInvoice ? (
        <DigitalbSingleExpandedInvoice
          utilityName={utilityName}
          invoice={digitalbSliceState.singleInvoice}
          globalDataSliceState={globalDataSliceState}
          digitalbSliceState={digitalbSliceState}
        />
      ) : isDigitalbOTT ? (
        <DigitalbOTT selectedContractInfo={myContractsSliceState.selectedContractInfo}
        utilityName={utilityName}
        defaultButtonStyle={props.defaultButtonStyle}
        selectedButtonStyle={props.selectedButtonStyle}
        digitalbSliceState={digitalbSliceState}
        globalDataSliceState={globalDataSliceState}
        utilityInfo={props.utilityInfo} /> // Render DigitalbOTT component if the condition is true
      ) : (
        <Digitalb
          selectedContractInfo={myContractsSliceState.selectedContractInfo}
          utilityName={utilityName}
          defaultButtonStyle={props.defaultButtonStyle}
          selectedButtonStyle={props.selectedButtonStyle}
          digitalbSliceState={digitalbSliceState}
          globalDataSliceState={globalDataSliceState}
          utilityInfo={props.utilityInfo}
        />
      )}
          <Grid container justifyContent={"center"}>
            <Grid container item md={3} xs={3}>
              {digitalbSliceState.isLoading && (
                <Lottie
                  animationData={smallLoadingAnimation}
                  loop={true}
                  autoplay={true}
                />
              )}
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid
        container
        item
        md={4.5}
        justifyContent={"left"}
        sx={{ "@media (max-width: 899px)": { justifyContent: "center" } }}
      >
        <MyContractsTest utilityName={utilityName} currentLocation="utility" />
      </Grid>
    </Grid>
  );
};

export default UtilityTaksat;
